import Flickity from "../../node_modules/flickity";

document.addEventListener("alpine:init", () => {
    Alpine.data("cardSlider", () => ({
        slider: null,
        slides: null,
        sliderContainer: null,
        init() {
            this.initSlider();
            this.updateTabIndexes(this.slides);

            pegasus.onResizeFinished(() => {
                this.sliderResize();
            }, true);
        },
        initSlider() {
            if (this.slider !== null) {
                this.slider.destroy();
            }

            this.sliderContainer = this.$refs.slider;
            this.slides = this.sliderContainer.querySelectorAll(".slide");

            this.slider = new Flickity(this.sliderContainer, {
                cellAlign: "left",
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                on: {
                    settle: () => {
                        this.updateTabIndexes(this.slides);
                    },
                    change: () => {
                        this.updateTabIndexes(this.slides);
                    },
                },
            });
        },
        updateTabIndexes(slides) {
            // The viewport is overflow-visible and several slides show at
            // once, so focus follows what overlaps the container rather than
            // the single selected slide.
            const bounds = this.sliderContainer.getBoundingClientRect();

            slides.forEach((slide) => {
                const rect = slide.getBoundingClientRect();
                const isVisible =
                    rect.right > bounds.left && rect.left < bounds.right;

                const slideElements = slide.querySelectorAll("a, button");

                slideElements.forEach((element) => {
                    if (isVisible) {
                        element.removeAttribute("tabindex");
                    } else {
                        element.setAttribute("tabindex", "-1");
                    }
                });
            });
        },
        sliderResize() {
            if (this.sliderContainer === null) return;

            const flickitySliders =
                this.sliderContainer.querySelectorAll(".flickity-slider");

            flickitySliders.forEach((slider) => {
                let height = 0;

                this.slides.forEach((slide) => {
                    slide.style.height = "";
                    if (slide.offsetHeight > height) {
                        height = slide.offsetHeight;
                    }
                });

                this.slides.forEach((slide) => {
                    slide.style.height = height + "px";
                });

                slider.style.height = "";
                slider.style.height = height + "px";
            });
        },
    }));
});
